export default __webpack_public_path__ + "static/media/HOME_BANNER_2.bfb66e82.jpg";